// extracted by mini-css-extract-plugin
export default {"chineseDocks":"chinese-docks_chineseDocks__tw4Ax"};